<template>
<div class="main">
  <router-link to="/" > <img class="close" :src="this.srcHomeButton" alt=""> </router-link>
  <a href="http://midi.espol.edu.ec"> <img class="home" :src="this.srcCloseButton" alt=""></a>
  
  <div class="about">
    <div class="m-color">
      <br>
      <h2 class="maintitle">Fomentar la educación de niños con TEA mediante herramientas digitales interactivas</h2> <h2> “Loly en Tiempos de Covid con Kike y Gaby” </h2> <h2> Cuento animado con Pictogramas</h2>
      <h1 class="cred">Créditos</h1>
    </div>
      
      <div class="container">
        <div class="wrapper">
        <h2 class="m-color">Equipo de Trabajo</h2>
        <div>
          <p class="m-color">Animación Cuento y Pictogramas</p>
          <p>César Manuel Arteaga Lucas <br>Christian Cristofer Castro Castro</p>
        </div>
        <div>
          <p class="m-color">Diseño e ilustración del cuento</p>
          <p>Hugo Christian Cedeño Palma <br>Rebecca Alejandra De La Cruz Rosado </p>
          
        </div>
        <div>
          <p class="m-color">Elaboración y revisión de historia y guiones</p>
        <p>Hugo Christian Cedeño Palma <br>Rebecca Alejandra De La Cruz Rosado <br>Psc. Ed. Lenny Gina Párraga Toala 
          <br> Psc. Génesis Estefanía Reyes Encalada <br> Ph.D. Nayeth Idalid Solórzano Alcívar</p>
        
      </div>

      <div>
        <h2 class="m-color">Profesores y Turores de FADCOM</h2>
        <p>M.Sc. Jaqueline Mejía Luna <br>
        M.Sc. Carlos Gonzalez <br>
        Ph.D. Nayeth Idalid Solórzano Alcívar <br>
        M.Sc. Da Hee Park Kim <br>
        M.Sc. Elizabeth Estephania Elizalde Rios</p>
      </div>
      </div>

      <div class="wrapper">
        <h2 class="m-color">Gestores del Proyecto</h2>
        <div>
          <p class="m-color">Directora Proyectos de Investigación MIDI</p>
          <p>Ph.D. Nayeth Idalid Solórzano Alcívar</p>
          
        </div>

        <h2 class="m-color">Colaboradores</h2>
        <p class="m-color">Voz Loly</p>
        <p>M.Sc. Diana Ruth Macias Larrea Velastegui</p>
        <p class="m-color">Diseño iconos y destacados</p>
        <p>Kleber José Avalino Mosquera</p>

        <h2 class="m-color">Créditos Institucionales y colaboración especial </h2>
        <p>Escuela Superior Politécnica del Litoral </p> <p>Facultad de Arte, Diseño y Comunicación Audiovisual</p><p>Fundación Asperger Ecuador</p>
<p>Federación Ecuatoriana Del Espectro Autista (FEDEA)</p>

      </div>
        
      </div>
      <br>
      <div>
        <img class="logo-fadcom" :src="this.fadcom" alt="">
        <img class="logo-fedea" :src="this.midi" alt="">
      </div>
      <br>
      
  </div>
</div>
  
  
</template>

<script>
export default {
  data(){
    return{
      fondo: require('../assets/creditos.png'),
      espol: require('../assets/espol.png'),
      fadcom : require('../assets/fadcom.png'),
      cidis: require('../assets/cidis.png'),
      fedea: require('../assets/fedea.png'),
      midi: require('../assets/logomidi.png'),
       srcHomeButton: require("../assets/home_button.png"),
       srcCloseButton: require("../assets/close_button.png"),
       myWindow : ''
    }
  }, mounted(){
 this.myWindow = window.location
  },
  methods: {
    limpiar(){
      localStorage.clear();
    }
    
  }
}
</script>

<style scoped>
*{
  font-weight: bold;
}
.home{
  width: 80px;
  position: absolute;
  right: 20px;
  top: 10px;
}
.close{
  width: 80px;
  position: absolute;
  left: 20px;
  top: 10px;
}
.main{
   background-image: url('../assets/creditos.png');
   background-position: center center;
   background-size: cover;
   background-repeat: no-repeat;
   margin: 0;
   height: 100vh;
   overflow: auto;
}
.m-color{
  color: green;
}
.about{
  max-width: 1000px;
  margin: 0 auto;
  box-sizing: border-box;
  
}
.container{
  display: flex;
  flex-wrap: wrap;
}
.wrapper{
  width: 50%;
  box-sizing: border-box;
  margin: 0;

}
.logo-fadcom{
  height: 60px;
  margin: 0 10px;
}
.logo-fedea{
  height: 100px;
  margin: 0 10px;
}
@media only screen and (max-width: 1100px) {
  .maintitle{
    width: 80%;
    margin: 0 auto;
  }
}
@media only screen and (max-width: 850px) {
  .maintitle{
    width: 60%;
    margin: 0 auto;
  }
  .cred{
    font-size: 12pt ;
  }
.about{
    padding: 5px;
  }
  h2{
    font-size: 10pt;
  }
  p{
    font-size: 9pt;
  }
  .logo-fadcom{
    height: 40px;
  }
  .logo-fedea{
    height: 60px;
  }
  .home{
    width: 60px;
  }
  .close{
    width: 60px;
  }
}
@media only screen and (max-width: 640px) {
  .about{
    padding: 5px;
  }
  h2{
    font-size: 9pt;
  }
  p{
    font-size: 8pt;
  }
  .logo-fadcom{
    height: 30px;
  }
  .logo-fedea{
    height: 50px;
  }
  .home{
    width: 50px;
  }
  .close{
    width: 50px;
  }
}

</style>